const PROD = 'prod'
const TEST = 'test'

export { PROD, TEST }
